export default "__VITE_ASSET__Cnkv6fo1__"